import Swiper from 'swiper'
import $ from 'jquery'

export default {
  init() {
    $( ".awards--mobile .swiper-container" ).each(function( index ) {
      const s = new Swiper($(this)[0], {
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: false,
        },
        on: {
          slideChange: function() {
            $(this.$el).find('.bottleSlider-currentSlide').text(this.realIndex + 1 < 10 ? `0${this.realIndex + 1}` : this.realIndex + 1)
          },
        },
      })
    })
  }
}
